import { Directive, HostBinding, Input } from '@angular/core';
type Size =
  | 8
  | 10
  | 12
  | 14
  | 16
  | 18
  | 20
  | 24
  | 28
  | 30
  | 32
  | 40
  | 48
  | 56
  | 64;

@Directive({
  host: {
    'class': 'sizeable',
  },
})
export class SizeableDirective {
  @HostBinding('style.width.px')
  @HostBinding('style.height.px')
  @HostBinding('style.fontSize.px')
  @Input()
  size?: Size;
  @Input() disabled: boolean = false;

  ngOnChanges() {}
}
